import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { KonstantesServiceModule } from '..';
import { KonstantesListComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    KonstantesServiceModule
  ],
  declarations: [KonstantesListComponent],
  exports: [KonstantesListComponent],

})
export class KonstantesListComponentModule { }
